import { datadogRum } from "@datadog/browser-rum";
import { datadogLogs } from "@datadog/browser-logs";

const applicationId = "e510cdce-4b4c-44b0-ba38-009a6490bba7";
const clientToken = "pub8b60b8d9ed14f8b9bf293c6e2433f1f9";
const site = "datadoghq.com";
const service = "discovery-copilot-frontend";
const env = "dev";
const version = "2.0.0";

const apiOrigin =
  (import.meta.env.VITE_API_ORIGIN as string | undefined) || window.location.origin;

const allowedTracingUrls = [
  apiOrigin,
  (url: string) => url.startsWith(window.location.origin + "/api/"),
  /^https:\/\/api\.chat\.jjs88\.net/,
  /^https:\/\/chat\.jjs88\.net/,
];

datadogRum.init({
  applicationId,
  clientToken,
  site,
  service,
  env,
  version,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100,
  traceSampleRate: 100,
  trackResources: true,
  trackLongTasks: true,
  trackUserInteractions: true,
  defaultPrivacyLevel: "mask-user-input",
  allowedTracingUrls,
});
console.log("[RUM] initialized", { service, env, version });

datadogLogs.init({
  clientToken,
  site,
  service,
  env,
  version,
  forwardErrorsToLogs: true,
  forwardConsoleLogs: ["warn", "error", "info"],
  forwardReports: "all",
  sessionSampleRate: 100,
});
console.log("[Logs] initialized", { service });

export const log = datadogLogs.logger;
